export const ROLE_STEP = 'ROLE_STEP'
export const BUSINESS_DETAILS_STEP = 'BUSINESS_DETAILS_STEP'
export const SERVICES_STEP = 'SERVICES_STEP'
export const GENERAL_INFO_STEP = 'GENERAL_INFO_STEP'
export const COMPLETED_STEP = 'COMPLETED_STEP'

export const STEPS = [
  ROLE_STEP, BUSINESS_DETAILS_STEP, SERVICES_STEP, GENERAL_INFO_STEP, COMPLETED_STEP
]